import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Zap } from "lucide-react";

export const UsageMeter = ({ refresh = 0, className = "" }) => {
  const [u, setU] = useState(null);

  useEffect(() => {
    let active = true;
    api.get("/usage/ai").then((r) => { if (active) setU(r.data); }).catch(() => {});
    return () => { active = false; };
  }, [refresh]);

  if (!u || u.unlimited || u.limit == null) return null;

  const used = Math.min(u.used, u.limit);
  const pct = Math.min(100, Math.round((u.used / u.limit) * 100));
  const near = u.remaining <= Math.max(1, Math.ceil(u.limit * 0.2));
  const out = u.remaining <= 0;
  const barColor = out ? "bg-red-500" : near ? "bg-amber-500" : "bg-emerald-500";
  const textColor = out ? "text-red-600" : near ? "text-amber-600" : "text-slate-600";
  const canUpgrade = u.plan !== "pro" && u.plan !== "enterprise";

  return (
    <div data-testid="ai-usage-meter" className={`rounded-xl border border-slate-200 bg-white px-4 py-3 ${className}`}>
      <div className="flex items-center justify-between mb-1.5">
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500">
          <Zap className="h-3.5 w-3.5" /> AI analyses today
        </span>
        <span data-testid="ai-usage-count" className={`text-sm font-data font-semibold ${textColor}`}>{used}/{u.limit}</span>
      </div>
      <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
        <div className={`h-full rounded-full transition-all duration-300 ${barColor}`} style={{ width: `${pct}%` }} />
      </div>
      {near && (
        <p className={`text-xs mt-2 ${textColor}`} data-testid="ai-usage-warning">
          {out ? "You've hit today's limit — it resets tomorrow." : `Only ${u.remaining} left today.`}
          {canUpgrade && (
            <> <Link to="/dashboard/billing?plan=pro" data-testid="ai-usage-upgrade-link" className="font-semibold underline hover:no-underline">Upgrade for more →</Link></>
          )}
        </p>
      )}
    </div>
  );
};

export default UsageMeter;
